import { render, staticRenderFns } from "./ExpandedPrices.template.vue?vue&type=template&id=bb4377aa&"
var script = {}
import style0 from "./ExpandedPrices.template.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports